import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Alert,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';

import InformationSubMenu from '@/components/nav/InformationSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import W2GPopup from '@/components/ui/W2GPopup';
// import W2Popup from '@/components/ui/W2Popup';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';
import { getLastDateOfTheMonth } from '@/utils/utils';

const FormW2G = () => {
  const [open, setOpen] = useState(false);
  // const projects = [
  //   {
  //     id: 1,
  //     title: 'Enter Payer & Winner Details',
  //     description:
  //       'Provide the payer’s EIN, name, and address, along with the winner’s SSN, name, and address.',
  //     src: '/assets/images/w2g-steps-img.webp',
  //     link: '',
  //     color: '#36454F',
  //   },
  //   {
  //     id: 2,
  //     title: 'Report Winnings & Withholding',
  //     description:
  //       'Enter the total gambling winnings and any federal or state tax withheld.',
  //     src: '/assets/images/w2g-steps-img.webp',
  //     link: '',
  //     color: '#126d32',
  //   },
  //   {
  //     id: 3,
  //     title: 'Review & Transmit',
  //     description:
  //       'Securely review your return for accuracy and transmit it to the IRS and state with ease.',
  //     src: '/assets/images/w2g-steps-img.webp',
  //     link: '',
  //     color: '#292852',
  //   },
  // ];
  // Track scroll progress
  // const { scrollYProgress } = useScroll();

  // Smooth the scroll progress
  // const smoothProgress = useSpring(scrollYProgress, {
  //   stiffness: 100,
  //   damping: 20,
  //   restDelta: 0.006,
  // });

  const layoutWrapperContents: LayoutWrapperContents = {
    Heading: `Simplify Your W-2 Filing Process`,
    SubHeading: `E-file your W-2 forms now with TaxZerone for a hassle-free experience.`,
    CtaText: 'File W-2  Now!',
    CtaSubHeading: ``,
    CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2`,
    isActive: false,
  };

  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 3, 31));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 3, 31)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);
  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Day</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };

  return (
    <AppLayout
      LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="E-file IRS Form W-2G Online for 2025 | TaxZerone"
          description="File IRS Form W-2G for 2025 online with TaxZerone. Report all gambling winnings and any withheld taxes to stay fully compliant with IRS filing requirements"
          keywords=""
          canonical="information-returns/efile-irs-form-w-2g/"
          jsonLdPricing="2.49"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="57448"
          ogShareImg="assets/images/information-share-img.png"
        />
      }
    >
      <W2GPopup />
      <InformationSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
      >
        <Box
          sx={{
            background:
              'linear-gradient(90deg,rgba(0, 78, 100, 1) 35%, rgba(179, 92, 55, 1) 85%)',
            p: 1.5,
            px: 2.5,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 1, md: 2 }}
            justifyContent="space-between"
            alignItems="center"
          >
            <Box sx={{ ml: 0.8 }}>
              <Typography
                component="div"
                variant="body1"
                sx={{
                  textAlign: { xs: 'left', sm: 'left' },
                  fontSize: { xs: 15, sm: 17, md: 18, lg: '1.25rem' },
                  color: '#ccc',
                  lineHeight: 1.3,
                }}
              >
                <strong>📢 Deadline Has Passed! </strong> E-File Your 2025{' '}
                <b style={{ color: '#fff' }}> Form W-2G</b> Today to Stay
                IRS-Compliant and Avoid Penalties.
              </Typography>
            </Box>
            <Box>
              <Box>
                {/* <Typography
                  variant="body2"
                  sx={{
                    textAlign: 'center',
                    mb: { xs: 1, sm: 1 },
                    lineHeight: 1.3,
                  }}
                >
                  Time left to file before the deadline{' '}
                  <Hidden smUp>
                    <br />
                  </Hidden>
                  (
                  <span style={{ fontWeight: 600, color: '#fff' }}>
                    Feb 02, 2026
                  </span>
                  ):
                </Typography> */}
                <Countdown date={lastDayTaxSeason} renderer={renderer} />
              </Box>
            </Box>
            <Box>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2g`}
                sx={{
                  backgroundColor: '#4269e2',
                  '&:hover, &:focus': {
                    backgroundColor: '#fff',
                    color: '#2c5257',
                  },
                  px: 2,
                  color: '#fff',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                Get started
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container>
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                E-File{' '}
                <span className="highlight-container">
                  <span className="highlight">Form W-2G</span>
                </span>{' '}
                Online
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                <span style={{ fontWeight: 600 }}>
                  {' '}
                  Looking to report gambling winnings?
                </span>{' '}
                File Form W-2G accurately with our{' '}
                <span style={{ fontWeight: 600 }}>IRS-authorized</span> e-file
                service.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                We support tax years{' '}
                <span style={{ fontWeight: 600 }}>2025</span>, and 2024.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2g`}
                  >
                    Start Filing Now
                  </Button>
                  {/* <Typography
                    variant="body2"
                    sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                  >
                    Takes less than 5 minutes
                  </Typography> */}
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/w2g-landing-img.webp" />
                <source srcSet="/assets/images/w2g-landing-img.png" />
                <img
                  src="/assets/images/w2g-landing-img.png"
                  alt="E-File Form W-2G Online "
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/w2g-landing-img-sm.webp" />
                <source srcSet="/assets/images/w2g-landing-img-sm.png" />
                <img
                  src="/assets/images/w2g-landing-img-sm.png"
                  alt="E-File Form W-2G Online "
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                Affordable Pricing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 0,
                  textAlign: 'left',
                }}
              >
                Starting at just{' '}
                <Box
                  component="strong"
                  sx={{
                    color: '#ffe400',
                    fontSize: { xs: 24, sm: 30 },
                  }}
                >
                  $2.49
                </Box>
                , with prices as low as{' '}
                <Box
                  component="strong"
                  sx={{
                    fontSize: { xs: 24, sm: 30 },
                  }}
                >
                  $0.59
                </Box>{' '}
                per form for bulk filings.
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 160, md: 160 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              <Button
                size="large"
                variant="contained"
                href="/pricing/#informationreturns"
                sx={{
                  boxShadow: 'none',
                  borderRadius: 2,
                  mb: 0.5,
                  textTransform: 'none',
                  backgroundColor: '#fff',
                  color: '#0a7581',
                  '&:hover, &:focus, &:active': {
                    color: '#fff',
                    backgroundColor: '#172b6b',
                  },
                }}
              >
                See Pricing
              </Button>
              <Typography
                variant="body2"
                sx={{ mt: 0, mb: 0, fontSize: { xs: 11, sm: 14 } }}
              >
                For your return volume
              </Typography>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                What is Form W-2G?{' '}
              </Typography>
              <Typography variant="body1">
                <span style={{ fontWeight: 600 }}> Form W-2G</span> is a tax
                document used to report certain gambling winnings to the IRS.
                It&apos;s issued when gambling winnings exceed specific
                thresholds, which vary by type of gambling (bingo, keno, etc.).
                The form includes the amount won, federal income tax withheld,
                and the payer&apos;s information. Winners receive this form from
                the gambling establishment for tax reporting purposes.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <picture>
                <source
                  srcSet="/assets/images/gambling-img.webp"
                  className="img-responsive"
                  width={650}
                  height={600}
                />
                <source
                  srcSet="/assets/images/gambling-img.png"
                  className="img-responsive"
                  width={650}
                  height={600}
                />
                <img
                  src="/assets/images/gambling-img.png"
                  alt=" What is Form W-2G?"
                  className="img-responsive"
                  loading="lazy"
                  width={650}
                  height={600}
                />
              </picture>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How to Complete{' '}
                <span className="highlight-container">
                  <span className="highlight">IRS Form W-2G</span>
                </span>{' '}
                in 3 Easy Steps with TaxZerone?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing Form W-2G electronically with TaxZerone is quick and
                simple:
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            sx={{ justifyContent: 'center', alignItems: 'center' }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/w2g-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/w2g-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/w2g-steps-img.png"
                  alt="How to Complete IRS Form W-2G in 3 Easy Steps with TaxZerone"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Enter Payer & Winner Details"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Enter Payer & Winner Details
                    </Typography>
                    <Typography variant="body1">
                      Provide the payer’s{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        EIN, name, and address
                      </span>
                      , along with the winner’s{' '}
                      <span style={{ fontWeight: 600 }}>
                        SSN, name, and address
                      </span>
                      .
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Report Winnings & Withholding"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Report Winnings & Withholding
                    </Typography>
                    <Typography variant="body1">
                      Enter the total{' '}
                      <span style={{ fontWeight: 600 }}>gambling winnings</span>{' '}
                      and any{' '}
                      <span style={{ fontWeight: 600 }}>federal or state</span>{' '}
                      tax withheld.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Review & Transmit"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Review & Transmit
                    </Typography>
                    <Typography variant="body1">
                      Securely review your return for accuracy and transmit it
                      to the IRS and state with ease.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>

              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2g`}
                >
                  E-file W-2G Now!
                </Button>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>
      {/* <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            mt: 0,
            pt: 5,
          }}
        >
          <Grid size={12} textAlign="center">
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 3,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              How to Complete{' '}
              <span className="highlight-container">
                <span className="highlight">IRS Form W-2G</span>
              </span>{' '}
              in 3 Easy Steps with TaxZerone
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 0,
                textAlign: 'center',
              }}
            >
              Filing Form W-2G electronically with TaxZerone is quick and
              simple:
            </Typography>
          </Grid>
          <Grid size={12} textAlign="center">
            <Box component={'div'} className="project-container">
              {projects.map((project, i) => {
                const targetScale = 0.8 - (projects.length - i) * 0.04;
                return (
                  <Card
                    title={project.title}
                    description={project.description}
                    src={project.src}
                    url={project.link}
                    color={project.color}
                    key={`p_${i}`}
                    i={i}
                    id={project.id ?? 0}
                    progress={smoothProgress}
                    range={[i * 0.04, 1.5]}
                    targetScale={targetScale}
                  />
                );
              })}
            </Box>
          </Grid>
        </Container>
      </Grid> */}
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why Choose TaxZerone for file Form W-2G online?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                TaxZerone is the trusted e-filing solution for reporting
                gambling winnings. Here’s why:
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-rule-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-rule-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-rule-icon.png"
                      alt="IRS Form Validations"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS Form Validations
                </Typography>
                <Typography variant="body1">
                  Our system automatically checks for errors and missing
                  details, ensuring your Form W-2G submission is accurate and
                  IRS-compliant. Reduce rejections and avoid penalties with our
                  built-in validation.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Bulk Filing Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Bulk Filing Support
                </Typography>
                <Typography variant="body1">
                  Easily upload and file multiple Form at once, saving time and
                  effort. Whether you&apos;re reporting a few winners or
                  handling large-scale filings, our bulk upload feature
                  streamlines the process.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/email-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/email-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/email-icon.png"
                      alt="Instant Recipient Copy Sharing "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Instant Recipient Copy Sharing
                </Typography>
                <Typography variant="body1">
                  Send recipient copies effortlessly via{' '}
                  <span style={{ fontWeight: 600 }}> ZeroneVault</span> for
                  secure digital access or opt for traditional postal mailing.
                  No more printing hassles—deliver copies quickly and reliably.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Best Pricing in the Industry "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Best Pricing in the Industry
                </Typography>
                <Typography variant="body1">
                  Enjoy affordable pricing tailored to your filing volume.
                  Whether filing a single form or handling bulk submissions,
                  TaxZerone offers cost-effective solutions without compromising
                  quality.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/form-based-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/form-based-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/form-based-icon.png"
                      alt="Simple Form-Based Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Simple Form-Based Filing
                </Typography>
                <Typography variant="body1">
                  Our intuitive platform lets you enter required details
                  seamlessly. Just fill in the fields, and we’ll take care of
                  the rest—no complex processes involved.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="Guided Filing Assistance "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Guided Filing Assistance
                </Typography>
                <Typography variant="body1">
                  Need help with a specific field? Our step-by-step guidance,
                  real-time prompts, and support ensure you complete your Form
                  W-2G filing with confidence.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          pb: 15,
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 0,
                  textAlign: 'center',
                }}
              >
                Form W-2G Filing{' '}
                <span className="highlight-container">
                  <span className="highlight">Deadline</span>
                </span>{' '}
                for the 2025 Tax Year
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            m={2}
            mt={2}
            py={{ xs: 0, sm: 4, md: 6 }}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/recipient-copies-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/recipient-copies-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/recipient-copies-icon.png"
                      alt="Send Recipient Copies"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Send Recipient Copies
                </Typography>
                <Typography variant="body1">
                  <b> Deadline:</b>{' '}
                  <span style={{ color: '#cc2936', fontWeight: 600 }}>
                    February 2, 2026
                  </span>{' '}
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="File with the IRS (e-file) "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  File with the IRS (e-file)
                </Typography>
                <Typography variant="body1">
                  <b> Deadline:</b>{' '}
                  <span style={{ color: '#cc2936', fontWeight: 600 }}>
                    March 31, 2026
                  </span>{' '}
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/paper-file-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/paper-file-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/paper-file-icon.png"
                      alt="File with the IRS (paper)"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  File with the IRS (paper)
                </Typography>
                <Typography variant="body1">
                  <b> Deadline:</b>{' '}
                  <span style={{ color: '#cc2936', fontWeight: 600 }}>
                    March 2, 2026
                  </span>{' '}
                </Typography>
              </Paper>
            </Grid>
            <Grid size={12}>
              <Box sx={{ mt: 3, textAlign: 'center' }}>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Submit your W-2G on time without hassle.
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    mt: 2,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2g`}
                >
                  Start Filing Now!
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box sx={{ px: { xs: 4, sm: 3, lg: 0 } }}>
        <Container
          maxWidth="lg"
          sx={{
            mb: 6,
            mt: { xs: -15, sm: -20 },
            backgroundColor: '#1d2337',
            backgroundBlendMode: 'soft-light',
            borderRadius: 4,
            px: { xs: 2, sm: 3 },
            py: 6,
            textAlign: 'center',
          }}
          className="curve-bg"
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 2,
              textAlign: 'center',
              color: '#fff',
            }}
          >
            Running Out of Time? File for an Extension
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, color: '#909090' }}>
            Get additional time to file or send recipient copies by requesting
            an extension below.
          </Typography>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            spacing={2}
            mx={2}
            mt={{ xs: 4, md: 4 }}
            pb={0}
            className="MuiGrid-root-width"
            sx={{}}
          >
            <Grid
              size={{ xs: 12, sm: 6, md: 6 }}
              textAlign="center"
              sx={{
                pt: '0 !important',
              }}
            >
              <Box
                sx={{
                  backgroundColor: 'rgba(0, 0, 0, .75)',
                  backgroundBlendMode: 'soft-light',
                  borderRadius: 4,
                  px: { xs: 2, lg: 2 },
                  py: 3,
                  minHeight: '100%',
                  border: '2px solid #353b4e',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 28, md: 24, sm: 22, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                    textAlign: 'center',
                    color: '#ccc',
                  }}
                >
                  Form 8809
                </Typography>
                <Typography variant="body1" sx={{ mb: 0, color: '#a2a2a2' }}>
                  Request an Extension to File Information Returns
                </Typography>
                <Box
                  sx={{
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    m: 0,
                    mt: 2,
                  }}
                >
                  <List sx={{ mb: 0 }}>
                    <ListItem
                      sx={{
                        py: 0.5,
                        alignItems: 'flex-start',
                        textAlign: 'center',
                        p: 0,
                      }}
                    >
                      <ListItemText sx={{ color: '#ccc' }}>
                        Running out of time to{' '}
                        <span style={{ fontWeight: 600 }}>
                          file Certain Gambling Winnings?
                        </span>{' '}
                        <Link
                          href="/tax-extension/efile-irs-form-8809-online/"
                          sx={{ color: '#fff8bc', textDecoration: 'underline' }}
                        >
                          File Form 8809 electronically
                        </Link>{' '}
                        to obtain an{' '}
                        <span style={{ fontWeight: 600 }}>
                          automatic 30-day IRS extension
                        </span>{' '}
                        to file Form W-2G with the IRS.
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 6 }}
              textAlign="center"
              sx={{
                pt: { sm: '0 !important' },
              }}
            >
              <Box
                sx={{
                  backgroundColor: 'rgba(0, 0, 0, .75)',
                  backgroundBlendMode: 'soft-light',
                  borderRadius: 4,
                  px: { xs: 2, lg: 2 },
                  py: 3,
                  minHeight: '100%',
                  border: '2px solid #353b4e',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 28, md: 24, sm: 22, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                    textAlign: 'center',
                    color: '#ccc',
                  }}
                >
                  Form 15397
                </Typography>
                <Typography variant="body1" sx={{ mb: 0, color: '#909090' }}>
                  Request an Extension to Furnish Recipient Statements
                </Typography>
                <Box
                  sx={{
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    m: 0,
                    mt: 2,
                  }}
                >
                  <List sx={{ mb: 0 }}>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start', p: 0 }}>
                      <ListItemText sx={{ color: '#ccc', textAlign: 'center' }}>
                        Running out of time to furnish recipient copies of w2g
                        form?{' '}
                        <Link
                          href="/tax-extension/file-irs-form-15397-online/"
                          sx={{ color: '#fff8bc', textDecoration: 'underline' }}
                        >
                          File Form 15397
                        </Link>{' '}
                        to request a{' '}
                        <span style={{ fontWeight: 600 }}>
                          one-time 30-day extension
                        </span>{' '}
                        to provide W2G recipient statements.
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} textAlign="center">
              <Button
                variant="contained"
                sx={{
                  mt: 3,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-secondary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2g`}
              >
                Get Extension Now
              </Button>
              <Typography
                variant="body2"
                sx={{ mt: 1, fontSize: { xs: 11, sm: 14 }, color: '#a2a2a2' }}
              >
                File Extension in Mins
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Why Get Started with TaxZerone Today?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Filing Form W-2G online is fast and hassle-free with TaxZerone. You
          can:
        </Typography>
        <Box
          sx={{
            textAlign: 'center',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <Stack
            spacing={1}
            direction={{ xs: 'column', sm: 'row' }}
            sx={{
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              m: 0,
            }}
          >
            <Box>
              <List>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    File quickly and accurately.
                  </ListItemText>
                </ListItem>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Stay compliant with IRS requirements.
                  </ListItemText>
                </ListItem>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Access your documents securely anytime with ZeroneVault.
                  </ListItemText>
                </ListItem>
              </List>
            </Box>
            <Box>
              <List>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Save time with bulk upload.
                  </ListItemText>
                </ListItem>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Enjoy the best pricing in the industry.
                  </ListItemText>
                </ListItem>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Benefit from expert support every step of the way.
                  </ListItemText>
                </ListItem>
              </List>
            </Box>
          </Stack>
        </Box>
        <Typography variant="body1" sx={{ color: '#f3f3f3' }}>
          Start your e-filing today and complete Form W-2G in just 3 simple
          steps!{' '}
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2g`}
          >
            E-file W-2G Now!
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What types of gambling winnings require Form W-2G?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Box component="div" sx={{ mt: 1, mb: 0 }}>
                      <TableContainer
                        sx={{
                          border: '1px solid #828282',
                          borderCollapse: 'collapse',
                          borderRadius: 1,
                        }}
                      >
                        <Table sx={{}} aria-label="Due Date Chart">
                          <TableHead>
                            <TableRow
                              sx={{
                                backgroundColor: '#ccc',
                              }}
                            >
                              <TableCell
                                sx={{
                                  color: '#444',
                                  width: 300,
                                  borderRight: '1px solid #828282',
                                  textAlign: 'left',
                                  borderBottom: '1px solid #828282',
                                  fontWeight: 'bold',
                                }}
                              >
                                Type of Gambling
                              </TableCell>

                              <TableCell
                                sx={{
                                  color: '#444',
                                  width: 300,
                                  textAlign: 'left',
                                  borderBottom: '1px solid #828282',

                                  fontWeight: 'bold',
                                }}
                              >
                                Threshold for W-2G Reporting
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow
                              sx={{
                                textAlign: 'center',
                                backgroundColor: '#f9f9f9',
                              }}
                            >
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  verticalAlign: 'center',
                                  textAlign: 'left',
                                }}
                              >
                                Horse Racing, Dog Racing, Jai Alai, & Similar
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderBottom: '1px solid #828282',
                                  verticalAlign: 'center',
                                  textAlign: 'left',
                                }}
                              >
                                $600 or more and at least 300 times the wager
                              </TableCell>
                            </TableRow>
                            <TableRow
                              sx={{
                                textAlign: 'center',
                              }}
                            >
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  verticalAlign: 'center',
                                  textAlign: 'left',
                                }}
                              >
                                Sweepstakes, Wagering Pools, Lotteries
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderBottom: '1px solid #828282',
                                  verticalAlign: 'center',
                                  textAlign: 'left',
                                }}
                              >
                                $600 or more and at least 300 times the wager
                              </TableCell>
                            </TableRow>
                            <TableRow
                              sx={{
                                textAlign: 'center',
                                backgroundColor: '#f9f9f9',
                              }}
                            >
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  verticalAlign: 'center',
                                  textAlign: 'left',
                                }}
                              >
                                Bingo/Slot Machines
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderBottom: '1px solid #828282',
                                  verticalAlign: 'center',
                                  textAlign: 'left',
                                }}
                              >
                                $1,200 or more
                              </TableCell>
                            </TableRow>
                            <TableRow
                              sx={{
                                textAlign: 'center',
                              }}
                            >
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  verticalAlign: 'center',
                                  textAlign: 'left',
                                }}
                              >
                                Keno
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderBottom: '1px solid #828282',
                                  verticalAlign: 'center',
                                  textAlign: 'left',
                                }}
                              >
                                $1,500 or more after deducting the wager
                              </TableCell>
                            </TableRow>
                            <TableRow
                              sx={{
                                textAlign: 'center',
                                backgroundColor: '#f9f9f9',
                              }}
                            >
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',

                                  verticalAlign: 'center',
                                  textAlign: 'left',
                                }}
                              >
                                Poker Tournaments
                              </TableCell>
                              <TableCell
                                sx={{
                                  verticalAlign: 'center',
                                  textAlign: 'left',
                                }}
                              >
                                $5,000 or more in winnings (after buy-in)
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Do I need to pay taxes on my gambling winnings?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    <span style={{ fontWeight: 600 }}> Yes</span>, gambling
                    winnings are considered taxable income by the IRS,
                    regardless of the amount. If your winnings exceed IRS
                    thresholds, federal tax withholding may apply. You must
                    report all gambling income on your tax return, even if you
                    do not receive Form W-2G. Proper reporting ensures
                    compliance and helps avoid penalties.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Can I e-file Form W-2G for multiple winners at once?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    Absolutely! TaxZerone offers{' '}
                    <span style={{ fontWeight: 600 }}> bulk e-filing</span>,
                    allowing casinos, racetracks, and gaming establishments to
                    file multiple Form W-2Gs in one go. This feature saves time,
                    reduces errors, and ensures IRS compliance, making it easier
                    to manage large volumes of filings.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. What if I make an error on Form W-2G after filing?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Mistakes happen, but they can be corrected. If you
                      discover an error in the originally filed Form W-2G, you
                      must submit a corrected version to the IRS. TaxZerone
                      simplifies the correction process, allowing you to quickly
                      amend mistakes and ensure accurate reporting.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. When is the deadline to file Form W-2G?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    The deadline to provide Form W-2G to the recipient is
                    <span style={{ fontWeight: 600 }}> January 31</span> of the
                    following year. If you are filing electronically with the
                    IRS, the deadline is{' '}
                    <span style={{ fontWeight: 600 }}> March 31</span>. Missing
                    these deadlines can result in penalties, so timely filing is
                    essential.
                    <Alert
                      severity="warning"
                      icon={false}
                      sx={{ mb: 3, mt: 0 }}
                    >
                      <b> Note:</b> If the due date falls on the weekend or
                      federal holiday, it is extended to next business days
                    </Alert>
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  6. How do I know if federal tax withholding applies to my
                  winnings?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    Federal tax withholding applies if the winnings exceed
                    certain IRS limits and meet specific payout criteria. For
                    example, winnings from a sweepstake or lottery over{' '}
                    <span style={{ fontWeight: 600 }}> $5,000</span> generally
                    require{' '}
                    <span style={{ fontWeight: 600 }}>
                      24% federal tax withholding
                    </span>
                    . TaxZerone ensures withholding details are included in your
                    filing, keeping you compliant.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  7. What information is required to file Form W-2G?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text" sx={{ mt: 1 }}>
                    <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                      <li>
                        <span style={{ fontWeight: 600 }}>Payer Details:</span>{' '}
                        Name, address, TIN, and contact information.{' '}
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          Winner’s Details:{' '}
                        </span>{' '}
                        Name, address, and TIN.{' '}
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>Winnings Info: </span>{' '}
                        Total winnings, date won, and type of wager.{' '}
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          Tax Withholding:{' '}
                        </span>{' '}
                        Amount of federal and state tax withheld (if any).{' '}
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          Transaction Info:{' '}
                        </span>{' '}
                        Wager amount and any backup withholding details (if
                        applicable){' '}
                      </li>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 10, md: 9 }}>
            <Box
              sx={{ textAlign: 'center', borderTop: '1px solid #ccc', mb: 4 }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mt: 4,
                }}
              >
                Still have questions?
              </Typography>
              <Typography variant="body1" sx={{ mt: 2 }}>
                If you&apos;re looking for more answers, refer to our{' '}
                <Link
                  href="https://support.taxzerone.com/"
                  target="_blank"
                  sx={{ color: '#0202ff' }}
                >
                  Knowledge Base & FAQs
                </Link>{' '}
                page or get in touch with our customer support team.
              </Typography>
              <Button
                variant="contained"
                sx={{
                  mt: 4,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href="/contact-us/"
              >
                Contact us
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default FormW2G;
